var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadTransactionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8045 5.67825C13.1257 5.38768 13.6464 5.38768 13.9675 5.67825C14.2887 5.96882 14.2887 6.43992 13.9675 6.73049L9.58158 10.6987C9.26043 10.9893 8.73973 10.9893 8.41858 10.6987L4.03261 6.73049C3.71146 6.43992 3.71146 5.96882 4.03261 5.67825C4.35377 5.38768 4.87446 5.38768 5.19562 5.67825L8.17769 8.37631V0.946429C8.17769 0.699873 8.54588 0.5 9.00006 0.5C9.45424 0.5 9.82243 0.699873 9.82243 0.946429V8.37635L12.8045 5.67825ZM1.70841 14.0417H16.2917C16.867 14.0417 17.3334 14.4562 17.3334 14.9676C17.3334 15.479 16.867 15.8935 16.2917 15.8935H1.70841C1.13312 15.8935 0.666748 15.479 0.666748 14.9676C0.666748 14.4562 1.13312 14.0417 1.70841 14.0417Z",
    fill: "#BE5400"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadTransactionIcon);
export default __webpack_public_path__ + "static/media/download-transaction-icon.738590ff657f314671e0f96e665b110f.svg";
export { ForwardRef as ReactComponent };